import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../lib/firebase";
import PageSkeleton from "./PageSkeleton";

const AuthRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [isVerifiedByAdmin, setIsVerifiedByAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  // Role to dashboard path mapping
  const roleDashboardMap = {
    admin: "/admin/dashboard",
    mentor: "/mentor/dashboard",
    user: "/user/dashboard"
  };

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, "users", currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUserRole(userData.role || "user");
            setIsVerifiedByAdmin(userData.isVerifiedByAdmin || false);
          } else {
            setUserRole(null);
            setIsVerifiedByAdmin(false);
          }
        } catch (err) {
          console.error("Error fetching user data:", err);
          setUserRole(null);
          setIsVerifiedByAdmin(false);
        }
      }
      
      setLoading(false);
    });

    return () => unsub();
  }, []);

  if (loading) return <PageSkeleton />;

  // If user is logged in
  if (user) {
    // Check verification status
    if (!isVerifiedByAdmin) {
      return <Navigate to="/auth/verification-pending" replace />;
    }

    // Redirect to appropriate dashboard based on role
    const redirectPath = roleDashboardMap[userRole] || "/user/dashboard";
    return <Navigate to={redirectPath} replace />;
  }

  // If user is not logged in, show auth pages
  return children;
};

export default AuthRoute;